<template>
  <div id="modal-default" aria-modal="true" class="modal fade show" role="dialog" style="display: block;">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <form @submit="submit">
          <div class="modal-header">
            <h5 class="modal-title">{{ item.id ? 'Edit' : 'Create' }} site group</h5>
            <button aria-label="Close" class="close" data-dismiss="modal" type="button"
                    @click="$emit('close')">
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-sm-12">
                <div class="form-group">
                  <label>Name</label>
                  <input v-model="currentSiteGroup.name"
                         autocomplete="off"
                         class="form-control"
                         name="name"
                         placeholder="Enter site group name"
                         required
                         type="text"
                  >
                  <small class="text-danger" v-if="errors.name">
                    {{ errors.name }}
                  </small>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer justify-content-between">
            <button class="btn btn-default" type="button" @click="$emit('close')">Cancel</button>

            <button v-if="isDebug"
                    class="close"
                    title="dev-only. clear fields"
                    type="button"
                    @click="clearData"
            ><i class="fas fa-trash"></i></button>

            <button v-if="isDebug"
                    class="close"
                    title="dev-only. fill with random data"
                    type="button"
                    @click="randomData"
            ><i class="fas fa-dice"></i></button>

            <button class="btn btn-primary" type="submit">Submit</button>
          </div>
        </form>

      </div>
    </div>
  </div>
</template>

<script>
import {generateRandomString} from '../helpers/makerUtils';

const MODE_CREATE = 'create';

export default {
  props: [
    'item',
    'mode',
  ],
  computed: {
    isCreateMode() {
      return this.mode === MODE_CREATE;
    },
    isDebug() {
      return process.env.NODE_ENV === 'development';
    }
  },
  methods: {
    randomData() {
      this.currentSiteGroup.name = 'Site Group ' + generateRandomString(8);
    },
    clearData() {
      this.currentSiteGroup.name = '';
    },
    valid() {
      let isValid = true;

      if (!this.currentSiteGroup.name || this.currentSiteGroup.name.trim() === '') {
        isValid = false;
        this.errors.name = 'Name is required';
      } else {
        this.errors.name = null;
      }

      return isValid;
    },
    submit(e) {
      e.preventDefault();
      if (!this.valid()) {
        return;
      }

      let url = null;
      let method = null;

      if (this.isCreateMode) {
        method = 'POST';
        url = '/sitegroup';
      } else {
        method = 'PUT';
        url = '/sitegroup/' + this.currentSiteGroup.id;
      }

      this.$http({
        url: url,
        data: {
          name: this.currentSiteGroup.name
        },
        method: method,
      }).then(() => {
        this.$emit('close');
        this.$emit('finish');
      }).catch((err) => {
        console.error(err);
        if (err.response.status === 422) {
          let errors = err.response.data;
          errors.forEach((error) => {
            if (!error.field) {
              this.$toastr.e(error.message);
            } else {
              this.$toastr.e(error.field + ': ' + error.message);
            }
          })
        } else {
          this.$toastr.e('Server error ' + err.response.status);
        }
      });
    },
  },
  mounted() {
    this.$store.dispatch('openModal');
  },
  beforeDestroy() {
    this.$store.dispatch('hideModal');
  },
  data() {
    return {
      currentSiteGroup: {
        ...this.item
      },
      errors: {
        name: null
      }
    };
  },
};
</script>